import { h, createRef } from 'preact';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useEffect, useRef, useState } from 'preact/hooks';

import getStyle from '../utils/getStyle';
import PostCard from '../components/post-card';

const getGridCount = (posts) => {
    const columns = posts.reduce( (prev, next) => {
        const current = next.columnSpan === 2 ? 1 : 0
        return prev + current
    }, 0)
    return columns + posts.length
}

const PostFeed = ({config: { title, posts }}) => {
    const postRefs = useRef([]);
    postRefs.current = posts?.map(
        (_, i) => postRefs.current[i] ?? createRef(),
    );

    const [feedHeight,setFeedHeight] = useState(560);

    function setHeight() {
        const postRect = postRefs.current?.[0].current.getBoundingClientRect();
        setFeedHeight(postRect?.height);
    }

    useEffect(() => {
        setHeight();

        'resize orientationchange'.split(' ').forEach(function (e) {
            window.addEventListener(e, setHeight);
        });
    });

    return (
        <_PostFeed className="-padded -padded--v -no-padding-right">
            <PostFeed__Wrap className="-wrap--left">
                <PostFeed__Header>
                    <PostFeed__Title dangerouslySetInnerHTML={{__html: title}} />
                </PostFeed__Header>
                <PostFeed__PostsWrap height={feedHeight}>
                    <PostFeed__Posts gridCount={getGridCount(posts)}>
                        {posts?.map(
                            (post,i, ) => <PostFeed__Post ref={postRefs.current[i]} {...post} />, 
                            )
                        }
                    </PostFeed__Posts>
                </PostFeed__PostsWrap>
            </PostFeed__Wrap>
        </_PostFeed>
    );
};

PostFeed.propTypes = {
    config: {
        title: PropTypes.string
    }
};

const _PostFeed = styled.section`
    background-color: ${getStyle('colors.primary--black')};
`;

const PostFeed__Wrap = styled.div``;

const PostFeed__Header = styled.header``;

const PostFeed__Title = styled.h3`
    text-transform: uppercase;
    color: white;
    letter-spacing: 0.34px;
    text-transform: uppercase;
    font-weight: ${getStyle('font-weights.black')};
    font-size: ${getStyle('font-sizes.body')};
`;

const PostFeed__PostsWrap = styled.div`
    height: ${({height}) => height}px;
    overflow: hidden;
`;

const PostFeed__Posts = styled.div`
    display: grid;
    gap:32px;
    grid-template-columns: repeat( ${({gridCount}) => gridCount}, 450px );
    overflow-x: scroll;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 20px;    
`;
 
const PostFeed__Post = styled(PostCard)`
    @media (min-width: ${getStyle('breakpoints.md')}) {
        max-width: none;
    }

    &:last-child {
        margin-right: 40px;
    }
`;

export default PostFeed;